"use client";

import { useState } from "react";
import {
  HiOutlineArrowSmallLeft,
  HiOutlineArrowSmallRight,
} from "react-icons/hi2";
import styles from "./style.module.css";

function MobileItems({ items }) {
  const [currentTab, setCurrentTab] = useState(0);

  function handleClickLeft() {
    if (currentTab < 0) setCurrentTab((currentTab) => currentTab + 1);
  }

  function handleClickRight() {
    const length = (items.length - 1) * -1;

    if (currentTab > length) {
      setCurrentTab((currentTab) => currentTab - 1);
    }
  }

  return (
    <div className={styles.container}>
      <div
        className={styles.items}
        style={{ transform: `translateX(calc(80% * ${currentTab}))` }}
      >
        {items.map((item, index) => (
          <div className={styles.item} key={`mobile-${item._key}`}>
            <p className={styles.index}>0{index + 1}</p>
            <h4>{item.title}</h4>
            <p className={styles.description}>{item.description}</p>
          </div>
        ))}
      </div>

      <div className={styles.btns}>
        <button disabled={!Boolean(currentTab)} onClick={handleClickLeft}>
          <HiOutlineArrowSmallLeft />
        </button>
        <button
          disabled={currentTab === (items.length - 1) * -1}
          onClick={handleClickRight}
        >
          <HiOutlineArrowSmallRight />
        </button>
      </div>
    </div>
  );
}

export default MobileItems;
